import React from 'react';

/**
 * Card Component
 * 
 * A reusable container component with consistent styling, glassmorphism effect, and hover animations.
 * 
 * @param {React.ReactNode} children - The content to render inside the card
 * @param {string} className - Additional CSS classes
 * @param {boolean} hover - Whether to enable hover effects (default: true)
 */
const Card = ({ children, className = "", hover = true }) => {
    return (
        <div className={`
      relative overflow-hidden
      bg-white/60 dark:bg-slate-800/40 backdrop-blur-md 
      border border-gray-200 dark:border-white/5 
      rounded-2xl p-6
      shadow-xl dark:shadow-none
      ${hover ? 'hover:bg-white/80 dark:hover:bg-slate-800/60 hover:border-purple-500/30 hover:shadow-2xl hover:shadow-purple-500/10 hover:-translate-y-1 transition-all duration-300' : ''}
      ${className}
    `}>
            {children}
        </div>
    );
};

export default Card;
